
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class NetworkNotification extends Vue {
  @Prop({ default: 'online' }) private networkStatus!: string;

  private get displayText() {
    return this.networkStatus === 'online' ? 'Back online.' : `You're offline.`;
  }
}
